import { createContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

export const CalendarContext = createContext()

const CalendarProvider = (props) => {
  const { children } = props
  const router = useRouter()

  // states
  const [season, setSeason] = useState('')
  const [navigationMonths, setNavigationMonths] = useState([])
  const [selectedDate, setSelectedDate] = useState('')
  const [showOverlay, setShowOverlay] = useState(false)
  const [scrollToast, setScrollToast] = useState(false)
  const [indicatorDate, setIndicatorDate] = useState('')
  const [routerChanged, setRouterChanged] = useState(false)
  const [seasonActiveState, setSeasonActiveState] = useState(true)

  const scrollToPage = () => setRouterChanged(true)
  const handleHistoryChange = () => scrollToPage()

  useEffect(() => {
    if (scrollToast) router.events.on('beforeHistoryChange', handleHistoryChange)
  }, [scrollToast])

  return (
    <CalendarContext.Provider
      value={{
        season,
        setSeason,
        navigationMonths,
        setNavigationMonths,
        selectedDate,
        setSelectedDate,
        showOverlay,
        setShowOverlay,
        setScrollToast,
        scrollToast,
        setRouterChanged,
        routerChanged,
        setIndicatorDate,
        indicatorDate,
        setSeasonActiveState,
        seasonActiveState
      }}
    >
      {children}
    </CalendarContext.Provider>
  )
}

CalendarProvider.propTypes = {
  children: PropTypes.array
}

export default CalendarProvider
